import { List } from 'immutable';
import { lruMemoize } from 'reselect';

const isSalesLoading = lruMemoize(
    (data) => data.get('loaded') === 'loading',
);
const getSalesTotal = (data) => data.get('total');
const getSalesPage = (data) => data.get('page');
const getSales = lruMemoize((data) => data.get('sales', List()));

const isFeaturedSalesLoading = lruMemoize(
    (data) => data.get('loaded') === 'loading',
);
const getFeaturedSales = lruMemoize((data) => data.get('sales', List()));

export {
    isFeaturedSalesLoading,
    isSalesLoading,
    getFeaturedSales,
    getSalesTotal,
    getSalesPage,
    getSales,
};
